import * as React from 'react';
import propz from 'propz';
import { Redirect, Route } from 'react-router';
import { ROLE } from '../../consts/user';
import { KIND } from '../../consts/school';

export const LoginRoute = ({ component: Component, user: user, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const userActiveRole = propz.get(user, ['activeRole']);
      const userActiveSchoolKind = propz.get(user, ['activeSchool', 'kind']);

      const isParent = userActiveRole === ROLE.PARENT;
      const isAdmin = userActiveRole === ROLE.ADMIN;
      const isManager = userActiveRole === ROLE.MANAGER;
      const isCoach = userActiveRole === ROLE.COACH;
      const isTeacher = userActiveRole === ROLE.TEACHER;
      const isStudent = userActiveRole === ROLE.STUDENT;
      const isAuthorized = propz.get(user, ['authorized']);

      const isSchoolUnion = userActiveSchoolKind === KIND.SCHOOL_UNION;
      const isSchoolUnionAdmin = isAdmin && isSchoolUnion;

      const isUserActiveRole = typeof userActiveRole !== 'undefined';
      const currentPathname = propz.get(props, ['location', 'state', 'from', 'pathname']);
      const currentSearch = propz.get(props, ['location', 'state', 'from', 'search']);

      switch (true) {
        case userActiveRole === ROLE.SLT:
          return <Redirect to={{ pathname: currentPathname && currentPathname.indexOf('/slt/') === 0 ? currentPathname : '/slt/overview', search: currentSearch }} />;
        case userActiveRole === ROLE.TOURNAMENT_FOLLOWER:
          return <Redirect to={{pathname: '/follow', search: '?union=' + encodeURIComponent(user.activeSchoolId || user.activeSchool?.id || '')}} />;
        case currentPathname && isUserActiveRole:
          return (
            <Redirect
              to={{
                pathname: currentPathname,
                state: props.location.state,
                search: currentSearch
              }}
            />
          );
        case isSchoolUnionAdmin:
          return (
            <Redirect
              to={{
                pathname: '/dashboard',
                state: props.location.state
              }}
            />
          );
        case isParent:
          return (
            <Redirect
              to={{
                pathname: '/home',
                state: props.location.state
              }}
            />
          );
        case isStudent:
          return (
            <Redirect
              to={{
                pathname: '/home',
                state: props.location.state
              }}
            />
          );
        case isTeacher || isCoach || isManager || isAdmin:
          return (
            <Redirect
              to={{
                pathname: '/calendar',
                state: props.location.state
              }}
            />
          );
        case isAuthorized:
          return <Component {...props} />;
        default:
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: props.location.state
              }}
            />
          );
      }
    }}
  />
);

LoginRoute.displayName = 'LoginRoute';

